import type { ModalData } from '..';

export interface PartnerModalData {
  modal: ModalData;
  title?: string;
  text?: string;
  moreInfo?: string;
  QRCode?: string;
  whatsappCta?: AdvantageWhatsappCta;
}

export interface AdvantageWhatsappCta {
  text?: string;
  url: string;
}
export interface PartnerModalProps extends PartnerModalData {}
